import { render, staticRenderFns } from "./PosList.vue?vue&type=template&id=19d54f5c&scoped=true"
import script from "./PosList.vue?vue&type=script&lang=js"
export * from "./PosList.vue?vue&type=script&lang=js"
import style0 from "./PosList.vue?vue&type=style&index=0&id=19d54f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d54f5c",
  null
  
)

export default component.exports